export const ROOT = 'rest';

export const DASHBOARD = 'dashboard';
export const PROFILE = 'profile';
export const CUSTOMER = 'customer';
export const ACCOUNT = 'account';
export const BALANCE = 'balance';
export const DEPOSIT = 'deposit';
export const TRANSFER = 'transfer';
export const WITHDRAWAL = 'withdrawal';
export const HISTORY = 'history';
export const REPORT = 'report';
export const SYSTEM = 'system-cache';
export const FIDO = 'fido';